export default __webpack_public_path__ + "static/media/story_other-7.10799a49.png";